import React from 'react';
import { getWindowNavigator } from 'core/window/windowService';

export interface GeoCoordinates {
    latitude: number;
    longitude: number;
}

export enum GeolocationStatus {
    DENIED = 'denied',
    GRANTED = 'granted',
    PROMPT = 'prompt',
}

export const useGeolocation = (): [GeoCoordinates | undefined, () => void, GeolocationStatus] => {
    const windowNavigator = getWindowNavigator();
    const [location, setLocation] = React.useState<GeoCoordinates | undefined>(undefined);
    const [status, setStatus] = React.useState<GeolocationStatus>(GeolocationStatus.PROMPT);
    const [invoke, setInvoke] = React.useState(false);

    const requestLocation = React.useCallback(() => {
        setInvoke(true);
    }, []);

    React.useEffect(() => {
        if (!invoke || !windowNavigator.geolocation) {
            setLocation(undefined);
            return;
        }

        const handleSuccess = (position: GeolocationPosition) => {
            setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            });
            setStatus(GeolocationStatus.GRANTED);
        };

        const handleError = () => {
            setLocation(undefined);
            setStatus(GeolocationStatus.DENIED);
        };

        windowNavigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    }, [windowNavigator, invoke]);

    return [location, requestLocation, status];
};
